module.exports = __webpack_public_path__ + "media/images/b2b_admin/mailer/logo-white-c84633e17ddc6580481889a3a284098d.png";